var map = {
	"./access-denied/access-denied.module": [
		"../../../../../src/app/access-denied/access-denied.module.ts",
		"access-denied.module"
	],
	"./blank-page/blank-page.module": [
		"../../../../../src/app/layout/blank-page/blank-page.module.ts",
		"blank-page.module"
	],
	"./bs-component/bs-component.module": [
		"../../../../../src/app/layout/bs-component/bs-component.module.ts",
		"common",
		"bs-component.module"
	],
	"./bs-element/bs-element.module": [
		"../../../../../src/app/layout/bs-element/bs-element.module.ts",
		"common",
		"bs-element.module"
	],
	"./charts/charts.module": [
		"../../../../../src/app/layout/charts/charts.module.ts",
		"charts.module",
		"common"
	],
	"./dashboard/dashboard.module": [
		"../../../../../src/app/layout/dashboard/dashboard.module.ts",
		"common",
		"dashboard.module"
	],
	"./form/form.module": [
		"../../../../../src/app/layout/form/form.module.ts",
		"common",
		"form.module"
	],
	"./grid/grid.module": [
		"../../../../../src/app/layout/grid/grid.module.ts",
		"common",
		"grid.module"
	],
	"./layout/layout.module": [
		"../../../../../src/app/layout/layout.module.ts",
		"common",
		"layout.module"
	],
	"./login/login.module": [
		"../../../../../src/app/login/login.module.ts",
		"common",
		"login.module"
	],
	"./not-found/not-found.module": [
		"../../../../../src/app/not-found/not-found.module.ts",
		"not-found.module"
	],
	"./order/order.module": [
		"../../../../../src/app/layout/order/order.module.ts",
		"common",
		"order.module"
	],
	"./server-error/server-error.module": [
		"../../../../../src/app/server-error/server-error.module.ts",
		"server-error.module"
	],
	"./signup/signup.module": [
		"../../../../../src/app/signup/signup.module.ts",
		"common",
		"signup.module"
	],
	"./tables/tables.module": [
		"../../../../../src/app/layout/tables/tables.module.ts",
		"common",
		"tables.module"
	],
	"./threed/threed.module": [
		"../../../../../src/app/layout/threed/threed.module.ts",
		"common",
		"threed.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// C:/Users/beast/repos/athlos-admin/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main